import { AxiosRequestConfig } from 'axios'
import apiEndpoints from 'const/endPoint'
import apiRequestor from 'services/apiRequestor'
import config from 'const/config'
import { User } from 'typings/userInfo'
import { readBlackBox } from 'helpers/windowUtility'
import {
  RecoverUserIDRequest,
  RecoverUserIdEligibilityCheckRequest,
  UserInfo
} from './typings'

const { APIGEE_CLIENT_ID } = config

export interface GetRecoverUserIdPayload
  extends Pick<User, 'dob' | 'firstName' | 'lastName' | 'email'> {
  fullAccountNumber: string
}

const recoverUserIdAPI = {
  getRecoverUserIdEligibilityCheck: async ({
    dob,
    firstName,
    lastName,
    email,
    fullAccountNumber
  }: GetRecoverUserIdPayload): Promise<RecoverUserIDRequest> => {
    const url = apiEndpoints.recoverUserId

    const userInfo: UserInfo = {
      fullAccountNumber,
      dob,
      firstName,
      lastName,
      email,
      iovation: readBlackBox()
    }

    const requestConfig: AxiosRequestConfig<RecoverUserIdEligibilityCheckRequest> =
      {
        url,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        params: {
          client_id: APIGEE_CLIENT_ID
        },
        data: { userInfo }
      }

    const response = await apiRequestor<RecoverUserIDRequest>({
      requestConfig,
      hasAccountInfo: false
    })

    return response.data
  }
}

export default recoverUserIdAPI
